import React, { useEffect, useState, useMemo } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import SubjectForm from "./SubjectForm";
import { getSubjects, addSubject, editSubject, deleteSubject } from "../../api/subjectApi";
import DynamicDataTable from "../../common/components/Common/DataListing";

const SubjectListing = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [type, setType] = useState(null);
  const [isActive, setIsActive] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [subject, setSubject] = useState({});

  const typeOptions = useMemo(() => ([
    { label: "All Types", value: null },
    { label: "Theory", value: "theory" },
    { label: "Practical", value: "practical" },
  ]), []);
  const activeOptions = useMemo(() => ([
    { label: "All", value: null },
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ]), []);

  const columns = [
    { field: "name", header: "Name" },
    { field: "code", header: "Code" },
    { field: "type", header: "Type" },
    { field: "category", header: "Category" },
    { field: "is_active", header: "Active", body: (row) => row.is_active ? "Yes" : "No" },
  ];

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {};
      if (query) params.q = query;
      if (type) params.type = type;
      if (isActive !== null) params.is_active = String(isActive);
      const res = await getSubjects(params);
      setItems(res.data || []);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load subjects");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [type, isActive]);

  const onSearch = () => fetchData();

  const onCreate = () => {
    setIsEditing(false);
    setSubject({ name: "", code: "", type: null, category: "", description: "", is_active: true });
    setIsModalVisible(true);
  };

  const onEdit = (row) => {
    setIsEditing(true);
    setSubject({ ...row });
    setIsModalVisible(true);
  };

  const onDelete = async (id) => {
    try {
      const res = await deleteSubject(id);
      if (res.success !== false) {
        toast.success(res.message || "Subject deleted");
        fetchData();
      } else {
        toast.error(res.message || "Delete failed");
      }
    } catch (err) {
      if (err?.response?.status === 409) {
        toast.warn(err.response.data?.message || "Cannot delete: subject is in use");
      } else {
        toast.error("Delete failed");
      }
    }
  };

  const onSubmit = async () => {
    try {
      const payload = { ...subject };
      if (!payload.name || !payload.name.trim()) {
        toast.warn("Name is required");
        return;
      }
      const res = isEditing ? await editSubject(subject.id, payload) : await addSubject(payload);
      if (res.success === false) {
        toast.error(res.message || "Save failed");
      } else {
        toast.success(isEditing ? "Subject updated" : "Subject added");
        setIsModalVisible(false);
        fetchData();
      }
    } catch (err) {
      toast.error("Save failed");
    }
  };

  return (
    <div>
      <ToastContainer />
      {/* <div className="flex gap-2 mb-3 align-items-center">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search name or code" />
        </span>
        <Dropdown value={type} options={typeOptions} onChange={(e) => setType(e.value)} placeholder="Type" />
        <Dropdown value={isActive} options={activeOptions} onChange={(e) => setIsActive(e.value)} placeholder="Active" />
        <Button label="Search" onClick={onSearch} className="btn-primary" />
        <Button label="Add Subject" onClick={onCreate} className="btn-primary" />
      </div> */}

      <DynamicDataTable
        data={items}
        subject="Subjects"
        permissionSubject="Curriculum"
        columns={columns}
        onCreate={onCreate}
        onEdit={onEdit}
        onDelete={(row) => onDelete(row.id)}
        loading={loading}
      />

      <Dialog header={isEditing ? "Edit Subject" : "Add Subject"} visible={isModalVisible} style={{ width: "40vw" }} onHide={() => setIsModalVisible(false)}>
        <SubjectForm subject={subject} setSubject={setSubject} />
        <div className="mt-3">
          <Button label={isEditing ? "Update" : "Add"} onClick={onSubmit} className="btn-primary" />
        </div>
      </Dialog>
    </div>
  );
};

export default SubjectListing; 